module.exports = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.332 2.66699C14.072 2.66699 14.666 3.26 14.666 4V12C14.666 12.74 14.072 13.333 13.332 13.333H2.66602C1.92602 13.333 1.33203 12.74 1.33203 12L1.33887 4C1.33887 3.26 1.92602 2.66699 2.66602 2.66699H13.332ZM2.66602 8V12H13.332V8H2.66602ZM2.66602 5.33301H13.332V4H2.66602V5.33301Z" fill="#212121" stroke-width="0.1"/>
</svg>`;

